function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
import PropTypes from "prop-types";
import Downshift from "downshift";
const MultiDownshift = props => {
  const stateReducer = (state, changes) => {
    switch (changes.type) {
      case Downshift.stateChangeTypes.clickItem:
        return {
          ...changes,
          isOpen: true
        };
      default:
        return changes;
    }
  };
  const handleSelection = selectedItem => {
    if (props.selectedItems.findIndex(i => i.value === selectedItem.value) !== -1) {
      props.onRemove(selectedItem);
    } else {
      props.onAdd(selectedItem);
    }
  };
  function getStateAndHelpers(downshift) {
    const {
      selectedItems
    } = props;
    return {
      selectedItems,
      ...downshift
    };
  }
  const {
    children,
    ...downshiftProps
  } = props;
  return /*#__PURE__*/React.createElement(Downshift, _extends({}, downshiftProps, {
    stateReducer: stateReducer,
    onChange: handleSelection,
    selectedItem: null
  }), downshift => children(getStateAndHelpers(downshift)));
};
MultiDownshift.displayName = "MultiDownshift";
MultiDownshift.propTypes = {
  selectedItems: PropTypes.array.isRequired,
  onAdd: PropTypes.func.isRequired,
  onRemove: PropTypes.func.isRequired,
  children: PropTypes.func.isRequired
};
export default MultiDownshift;
//# sourceMappingURL=MultiDownshift.js.map